import { render } from "./PartnerBenefits.vue?vue&type=template&id=75b8b8d0&scoped=true"
import script from "./PartnerBenefits.vue?vue&type=script&lang=js"
export * from "./PartnerBenefits.vue?vue&type=script&lang=js"

import "./PartnerBenefits.vue?vue&type=style&index=0&id=75b8b8d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b8b8d0"]])

export default __exports__